module.exports = __webpack_public_path__ + "static/cornell-149f4ae6947ed51d9db343bce5f5b1a8.png";